module.exports = __webpack_public_path__ + "static/media/atendimento-1.2798f9d3.png";